import React, { useCallback, useEffect, useState } from "react";
import style from "./index.module.css";
import { alertV2, user } from "../../../api/index.js";
import { parserAPI } from "../../../utils/parser.jsx";
import { toast } from "react-toastify";
import { formatDateTime, renderImage } from "../../../utils/helper.jsx";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { MentionsInput, Mention } from "react-mentions";
import classNames from "./mention.module.css";
import Attachment from "./attachment/index.jsx";
import AttachmentDownload from "./attachment/download.jsx";
const getNick = (name) => {
  if (!name) return "";
  const splitName = name.split(" ");
  let nick = "";
  splitName.forEach((s) => {
    nick += s.charAt(0);
  });

  return nick;
};
export const AlertLog = ({ alert_id, displayAction, updateLastLog }) => {
  const { config } = useAuth();
  const [attachment, setAttachment] = useState("");
  const [attachmentName, setAttachmentName] = useState("");
  const [attachmentComment, setAttachmentComment] = useState("");
  const [attachmentCommentName, setAttachmentCommentName] = useState("");
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const { email } = useAuth();
  async function getLogs() {
    try {
      const res = await alertV2.getAlertLogs(alert_id);
      const data = await parserAPI(res);
      // get latest action
      if (data.length > 0) {
        //sorted version
        const sortedData = data.sort((a, b) => {
          let da = new Date(a.event_date),
            db = new Date(b.event_date);
          return db - da;
        });
        const isResponse = sortedData.filter(
          (d) => d.event_name === "Response"
        );
        if (isResponse.length > 0) {
          updateLastLog(isResponse[0].event_action);
        } else {
          updateLastLog("");
        }
      } else {
        updateLastLog("");
      }
      setLogs(data);
    } catch (e) {
      toast.error(e.message);
    }
  }
  async function getUsers() {
    try {
      const res = await user.list();
      const data = await parserAPI(res);
      let user_list = [];
      data.map((u) => {
        user_list.push({
          id: u.email,
          display: u.firstname + " " + u.lastname,
        });
      });
      setUsers(user_list);
    } catch (e) {
      toast.error(e.message);
    }
  }
  useEffect(() => {
    getUsers();
  }, []);
  useEffect(() => {
    if (alert_id) getLogs();
  }, [alert_id]);
  const [showAddComment, setShowAddComment] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [logText, setLogText] = useState("");
  const [mentionElement, setMentionElement] = useState(null);

  const [selectedUser, setSelectedUser] = useState([]);

  const handleClickAddComment = (index) => {
    if (index === showAddComment) {
      setShowAddComment(null);
    } else {
      setShowAddComment(index);
    }
    setAttachmentComment(null);
    setAttachmentCommentName(null);
  };

  const handleOpenMention = (event) => {
    setMentionElement(event.currentTarget);
  };

  const handleAttachment = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setAttachment(undefined);
      return;
    }
    setAttachmentName(e.target.files[0].name);
    setAttachment(e.target.files[0]);
  };
  const handleAttachmentComment = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setAttachmentComment(undefined);
      return;
    }
    setAttachmentCommentName(e.target.files[0].name);
    setAttachmentComment(e.target.files[0]);
  };

  const handleSubmitComment = async (id) => {
    if (commentText) {
      const payload = {
        email: email,
        feedback: commentText,
        alert_logs_id: id,
      };
      const res = await alertV2.addLogFeedbackAttachment(
        id,
        payload,
        attachmentComment
      );
      setCommentText("");
      setAttachmentComment(null);
      getLogs();
    }
  };
  const handleSubmitLog = async () => {
    if (logText) {
      const payload = {
        email: email,
        event_details: logText,
        event_name: "comment",
      };
      const res = await alertV2.addLog(alert_id, payload);
      setLogText("");
      getLogs();
      setAttachment(null);
    }
  };
  const handleDelete = async (row) => {
    const res = await alertV2.deleteFeedback(row);
    getLogs();
  };
  const handleSubmitLogAttachment = async () => {
    if (logText) {
      const payload = {
        email: email,
        event_details: logText,
        event_name: "comment",
      };
      const res = await alertV2.addLogAttachment(alert_id, payload, attachment);
      setLogText("");
      getLogs();
      setAttachment(null);
    }
  };

  const handleCommentChange = (e) => {
    setCommentText(e.target.value);
  };
  const handleLogsTextChange = (e) => {
    setLogText(e.target.value);
  };

  const handleSelectUser = (email) => {
    if (selectedUser.includes(email)) {
      setSelectedUser((su) => su.filter((s) => s != email));
    } else {
      setSelectedUser((su) => [...su, email]);
    }
  };

  const isSelected = (email) => {
    return selectedUser.includes(email);
  };

  const showAction = (event, action) => {
    displayAction(event, action);
  };

  const openMention = Boolean(mentionElement);

  function CustomCell(val) {
    return (
      <td
        style={{
          padding: 0,
          borderBottom: "none",
          display: {
            md: "table-cell",
            sm: "block",
            xs: "block",
          },
          whiteSpace: "nowrap",
          paddingRight: "10px",
          verticalAlign: "top",
        }}
      >
        {val}
      </td>
    );
  }
  function CustomCellValue(val) {
    return (
      <td
        style={{
          padding: 0,
          borderBottom: "none",
          display: {
            md: "table-cell",
            sm: "block",
            xs: "block",
          },
        }}
      >
        {val}
      </td>
    );
  }

  return (
    <div
      style={{
        mt: 2,
        zIndex: 9,
        position: "relative",
        p: {
          sm: 3,
          xs: 1,
        },
      }}
    >
      <div className="d-flex align-items-center">
        <div className="bg-opacity-10 bg-white btn-attachment">
          <input
            type="file"
            onChange={handleAttachment}
            style={{ display: "none" }}
            id="input-file"
          />
          <label htmlFor="input-file" style={{ cursor: "pointer" }}>
            <i className="fa fa-paperclip fa-lg"></i>
          </label>
        </div>

        <div className="flex-fill ps-2">
          <div className="position-relative d-flex align-items-center">
            <div className="flex-1 border border-theme mentions">
              <MentionsInput
                placeholder="Add a comment"
                value={logText}
                onChange={handleLogsTextChange}
                className="mentions"
                classNames={classNames}
                a11ySuggestionsListLabel={"Suggested mentions"}
              >
                <Mention
                  trigger="@"
                  data={users}
                  className={classNames.mentions__mention}
                />
              </MentionsInput>
              {attachment ? (
                <div style={{ display: "flex" }}>
                  <div className={style.attachment}>
                    <div style={{ paddingTop: "3px" }}>
                      <i className="fa fa-paperclip"></i>
                    </div>
                    <div style={{ paddingTop: "3px" }}>{attachmentName}</div>
                  </div>
                </div>
              ) : null}
            </div>

            <div
              onClick={handleSubmitLogAttachment}
              className="position-absolute end-0 text-center"
            >
              <a href="#/" className="text-inverse text-opacity-50 me-2">
                <i className="fa fa-paper-plane fa-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      {logs
        .sort((a, b) => {
          let da = new Date(a.event_date),
            db = new Date(b.event_date);
          return db - da;
        })
        .map((log, index) => {
          return (
            <div
              key={log.alert_logs_id}
              className={"mt-3 mb-5"}
              style={{ fontSize: 13 }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  position: "relative",
                  alignItems: "stretch",
                }}
              >
                <div>
                  <div className={style.usernameWrapper}>
                    {getNick(`${log.user?.firstname} ${log.user?.lastname}`)}
                  </div>
                </div>
                <div
                  style={{
                    marginLeft: "10px",
                    flex: 1,
                    borderRadius: "10px",
                    overflowWrap: "anywhere",
                    "&.MuiGrid-item": { paddingTop: "15px" },
                  }}
                >
                  <div
                    className={"position-absolute"}
                    style={{
                      position: {
                        md: "absolute",
                        xs: "relative",
                        sm: "relative",
                      },
                      marginLeft: "10px",
                      right: "10px",
                      fontSize: {
                        md: "13px",
                        sm: "11px",
                        xs: "11px",
                      },
                      "&.MuiGrid-item": { paddingTop: "15px" },
                    }}
                  >
                    {formatDateTime(log.event_date)}
                  </div>
                  <div
                    className={"mb-1"}
                    style={{
                      display: {
                        md: log.event_name === "comment" ? "block" : "flex",
                        sm: "block",
                        xs: "block",
                      },
                    }}
                  >
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: "bold",
                        fontSize: "13px",
                        marginRight: "5px",
                      }}
                    >{`${log.user?.firstname} ${log.user?.lastname}`}</div>
                    <div
                      style={{
                        display: {
                          md: "flex",
                          xl: "flex",
                          sm: "block",
                          xs: "block",
                        },
                      }}
                    >
                      {log.event_name === "comment" ? (
                        <MentionsInput
                          placeholder="Add a comment"
                          value={log.event_details}
                          readOnly={true}
                          className="mentions small inline"
                          classNames={classNames}
                          a11ySuggestionsListLabel={"Suggested mentions"}
                        >
                          <Mention
                            trigger="@"
                            data={users}
                            className={classNames.mentions__mention}
                          />
                        </MentionsInput>
                      ) : (
                        <div>
                          has updated the Alarm to "<b>{log.event_action}</b>"
                        </div>
                      )}
                    </div>
                    {/*{log.action && log.action?.action_name !== "Re-open" ? (*/}
                    {/*  <div*/}
                    {/*    onClick={() => {*/}
                    {/*      showAction(log.event_action, log.action);*/}
                    {/*    }}*/}
                    {/*    style={{*/}
                    {/*      textDecoration: "underline",*/}
                    {/*      cursor: "pointer",*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    [ Details ]*/}
                    {/*  </div>*/}
                    {/*) : null}*/}
                  </div>
                  {log.action && (
                    <table>
                      <tbody>
                        {["Proceed with Inspection", "Monitor & Wait"].includes(
                          log.event_action
                        ) ? (
                          <tr>
                            {CustomCell("Feedback :")}
                            {CustomCellValue(log.action?.additional_comment)}
                          </tr>
                        ) : null}
                        {["Invalid"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("Description :")}
                            {CustomCellValue(log.action?.action_work)}
                          </tr>
                        ) : null}
                        {["Monitor & Wait"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("Duration of Monitor and Wait :")}
                            {CustomCellValue(log.action?.action_completed)}
                          </tr>
                        ) : null}
                        {["Proceed with Maintenance"].includes(
                          log.event_action
                        ) ? (
                          <tr>
                            {CustomCell("Inspection Completed :")}
                            {CustomCellValue(log.action?.action_completed)}
                          </tr>
                        ) : null}
                        {["Proceed with Maintenance"].includes(
                          log.event_action
                        ) ? (
                          <tr>
                            {CustomCell("Inspection Work Details :")}
                            {CustomCellValue(log.action?.action_work)}
                          </tr>
                        ) : null}
                        {["Proceed with Maintenance"].includes(
                          log.event_action
                        ) ? (
                          <tr>
                            {CustomCell("Confirmed Issue :")}
                            {CustomCellValue(log.action?.confirmed_issue)}
                          </tr>
                        ) : null}
                        {["Proceed with Maintenance"].includes(
                          log.event_action
                        ) ? (
                          <tr>
                            {CustomCell("Additional Comments :")}
                            {CustomCellValue(log.action?.additional_comment)}
                          </tr>
                        ) : null}
                        {["Proceed with Maintenance"].includes(
                          log.event_action
                        ) ? (
                          <tr>
                            {CustomCell("Attachment :")}
                            <td
                              style={{
                                padding: 0,
                                borderBottom: "none",
                                display: {
                                  md: "table-cell",
                                  sm: "block",
                                  xs: "block",
                                },
                              }}
                            >
                              {" "}
                              {log.attachments?.docs ? (
                                <AttachmentDownload
                                  docs={log.attachments?.docs}
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ) : null}
                        {/*Closed*/}

                        {["Closed"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("This Alarm is :")}
                            {CustomCellValue(
                              log.action?.action_completed === "Yes" ||
                                log.action?.action_completed ===
                                  "maintenance completed"
                                ? "Valid"
                                : "Invalid"
                            )}
                          </tr>
                        ) : null}

                        {["Closed"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("Total Engineers :")}
                            {CustomCellValue(`${log.action?.total_engineers}`)}
                          </tr>
                        ) : null}
                        {["Closed"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("Total Cost of Maintenance :")}
                            {CustomCellValue(
                              `${log.action?.maintenance_currency} ${log.action?.maintenance_cost}`
                            )}
                          </tr>
                        ) : null}
                        {["Closed"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("Man Hour Saved :")}
                            {CustomCellValue(`${log.action?.man_hour_saved}`)}
                          </tr>
                        ) : null}
                        {["Closed"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("Maintenance Work Details :")}
                            {CustomCellValue(log.action?.action_work)}
                          </tr>
                        ) : null}
                        {["Closed"].includes(log.event_action) ? (
                          <tr>
                            {CustomCell("Attachment :")}
                            <td
                              style={{
                                padding: 0,
                                borderBottom: "none",
                                display: {
                                  md: "table-cell",
                                  sm: "block",
                                  xs: "block",
                                },
                              }}
                            >
                              {" "}
                              {log.attachments?.docs ? (
                                <AttachmentDownload
                                  docs={log.attachments?.docs}
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  )}

                  {log.attachments?.docs && log.event_name === "comment" ? (
                    <div>
                      <Attachment docs={log.attachments?.docs} />
                    </div>
                  ) : null}
                  {/*{`${log.event_details}`}{" "}*/}
                </div>
              </div>
              {log.comments?.length === 0 ? (
                <div>
                  <div
                    onClick={() => handleClickAddComment(index)}
                    style={{
                      textDecoration: "underline",
                      marginLeft: "40px",
                      marginTop: "5px",
                      cursor: "pointer",
                      display: "flex",
                    }}
                  >
                    <div>Add Comment</div>
                  </div>

                  <div
                    style={{
                      paddingLeft: "40px",
                      display: showAddComment === index ? "block" : "none",
                    }}
                  >
                    <div className={"d-flex border border-theme mt-2"}>
                      <div className={"flex-1"}>
                        <MentionsInput
                          placeholder="Add comment"
                          value={commentText}
                          onChange={handleCommentChange}
                          className="mentions"
                          classNames={classNames}
                          a11ySuggestionsListLabel={"Suggested mentions"}
                        >
                          <Mention
                            trigger="@"
                            data={users}
                            className={classNames.mentions__mention}
                          />
                        </MentionsInput>
                        {attachmentComment ? (
                          <div style={{ display: "flex" }}>
                            <div className={style.attachment}>
                              <div style={{ paddingTop: "3px" }}>
                                <i className="fa fa-paperclip"></i>
                              </div>
                              <div
                                style={{ paddingTop: "3px", color: "#2A2E5D" }}
                              >
                                {attachmentCommentName}
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div style={{ cursor: "pointer" }}>
                        <input
                          type="file"
                          onChange={handleAttachmentComment}
                          style={{ display: "none" }}
                          id="input-file-comment"
                        />
                        <label
                          htmlFor="input-file-comment"
                          style={{
                            cursor: "pointer",
                            padding: "7px",
                            width: "36px",
                          }}
                        >
                          <i
                            className="fa fa-paperclip"
                            style={{ fontSize: "20px" }}
                          ></i>
                        </label>
                      </div>
                      <div
                        style={{
                          padding: "7px",
                          width: "36px",
                        }}
                      >
                        <i
                          className="fa fa-paper-plane"
                          onClick={() => handleSubmitComment(log.id)}
                          style={{
                            fill: "#1DCBFF",
                            cursor: "pointer",
                            fontSize: "20px",
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {log.comments?.length
                ? log.comments
                    .sort((a, b) => {
                      let da = new Date(a.created_at),
                        db = new Date(b.created_at);
                      return da - db;
                    })
                    .map((c, indexComment) => {
                      return (
                        <div
                          key={c.created_at}
                          spacing={1}
                          className={"mt-2"}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            position: "relative",
                            alignItems: "stretch",
                            paddingLeft: "50px",
                          }}
                        >
                          <div>
                            <div className={style.usernameWrapper}>
                              {getNick(
                                `${c.commenter?.firstname} ${c.commenter?.lastname}`
                              )}
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                marginLeft: "10px",
                                position: "relative",
                                p: 1,
                                borderRadius: 1,
                              }}
                            >
                              <div container spacing={1}>
                                <div
                                  item
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    fontSize: "13px",
                                    "&.MuiGrid-item": { paddingTop: "15px" },
                                  }}
                                >
                                  {formatDateTime(c.created_at)}
                                </div>

                                <div>
                                  <div
                                    style={{
                                      fontWeight: "bold",
                                      overflowWrap: "anywhere",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {`${c.commenter?.firstname} ${c.commenter?.lastname}`}
                                  </div>

                                  <div>
                                    <MentionsInput
                                      placeholder="Add a comment"
                                      value={c.comment}
                                      readOnly={true}
                                      className="mentions small"
                                      classNames={classNames}
                                      a11ySuggestionsListLabel={
                                        "Suggested mentions"
                                      }
                                    >
                                      <Mention
                                        trigger="@"
                                        data={users}
                                        className={classNames.mentions__mention}
                                      />
                                    </MentionsInput>
                                    {c.attachments?.docs ? (
                                      <Attachment docs={c.attachments?.docs} />
                                    ) : null}
                                  </div>
                                </div>
                                {c.email === email ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "5px",
                                      top: "10px",
                                    }}
                                  >
                                    <span>
                                      <img
                                        src="/icons/edit.png"
                                        style={{
                                          cursor: "pointer",
                                          width: "22px",
                                          marginRight: "5px",
                                          padding: "5px 4px",
                                        }}
                                        onClick={() => {}}
                                      />
                                    </span>
                                    <span>
                                      <img
                                        src="/icons/bin.png"
                                        style={{
                                          cursor: "pointer",
                                          width: "22px",
                                          marginRight: "5px",
                                          padding: "5px 4px",
                                        }}
                                        onClick={() => {
                                          handleDelete(c);
                                        }}
                                      />
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            </div>

                            {c.comments &&
                              c.comments.map((cc) => {
                                return (
                                  <div key={cc.id}>
                                    <div className="row">
                                      <div className="col-sm-1">
                                        <div className={style.usernameWrapper}>
                                          {getNick(
                                            `${cc.commenter.firstname} ${cc.commenter.lastname}`
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-sm-11">
                                        <div
                                          style={{
                                            background: "#ECECEC",
                                            p: 1,
                                            borderRadius: 1,
                                          }}
                                        >
                                          <div className="row">
                                            <div
                                              className="col-sm-2"
                                              style={{ fontWeight: "bold" }}
                                            >
                                              {cc.datetime}
                                            </div>
                                            <div
                                              className={"col-sm-10"}
                                              style={{
                                                color: "rgba(2, 33, 99, 0.50)",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {cc.name}
                                            </div>
                                            <div
                                              className={"col-sm-10"}
                                              style={{
                                                color: "rgba(2, 33, 99, 0.50)",
                                              }}
                                            >
                                              {cc.detail}
                                            </div>
                                            <div className="col-sm-2">
                                              <span>
                                                <img
                                                  src="/icons/edit.png"
                                                  style={{
                                                    cursor: "pointer",
                                                    width: "26px",
                                                    marginRight: "5px",
                                                    padding: "5px 4px",
                                                  }}
                                                  onClick={() => {}}
                                                />
                                              </span>
                                              <span>
                                                <img
                                                  src="/icons/bin.png"
                                                  style={{
                                                    cursor: "pointer",
                                                    width: "26px",
                                                    marginRight: "5px",
                                                    padding: "5px 4px",
                                                  }}
                                                  onClick={() => {}}
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    })
                : null}

              {log.comments?.length ? (
                <>
                  <div
                    className={"mt-1"}
                    style={{
                      textDecoration: "underline",
                      marginLeft: "80px",
                      mt: 1,
                      cursor: "pointer",
                    }}
                    onClick={() => handleClickAddComment(index)}
                  >
                    <i className="fa fa-reply"></i> Reply
                  </div>

                  <div
                    style={{
                      marginLeft: "70px",
                      display: showAddComment === index ? "block" : "none",
                    }}
                  >
                    <div className={"d-flex border border-theme mt-2"}>
                      <div className={"flex-1"}>
                        <MentionsInput
                          placeholder="Add Reply"
                          value={commentText}
                          onChange={handleCommentChange}
                          className="mentions"
                          classNames={classNames}
                          a11ySuggestionsListLabel={"Suggested mentions"}
                        >
                          <Mention
                            trigger="@"
                            data={users}
                            className={classNames.mentions__mention}
                          />
                        </MentionsInput>
                        {attachmentComment ? (
                          <div style={{ display: "flex" }}>
                            <div className={style.attachment}>
                              <div style={{ paddingTop: "3px" }}>
                                <i className="fa fa-paperclip"></i>
                              </div>
                              <div style={{ paddingTop: "3px" }}>
                                {attachmentCommentName}
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div style={{ cursor: "pointer" }}>
                        <input
                          type="file"
                          onChange={handleAttachmentComment}
                          style={{ display: "none" }}
                          id="input-file-reply"
                        />
                        <label
                          htmlFor="input-file-reply"
                          style={{
                            cursor: "pointer",
                            padding: "7px",
                            width: "36px",
                          }}
                        >
                          <i
                            className="fa fa-paperclip"
                            style={{ fontSize: "20px" }}
                          ></i>
                        </label>
                      </div>
                      <div
                        style={{
                          padding: "7px",
                          width: "36px",
                        }}
                      >
                        <i
                          className="fa fa-paper-plane"
                          onClick={() => handleSubmitComment(log.id)}
                          style={{
                            fill: "#1DCBFF",
                            cursor: "pointer",
                            fontSize: "20px",
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          );
        })}
    </div>
  );
};
